const addressRegex = new RegExp(/([0-9A-Za-zÀ-ÖØ-öø-ÿ ]+,\n?){2}\n? ?[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}/)
const dobRegex = new RegExp(/3. ([0-9]{2}\.){2}[0-9]{4}/)
const lineEight = new RegExp(/8. /)
//Added this into the adress regex but will keep here for future use
// const postcodeRegex = new RegExp(/^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/)
const namesRegex = new RegExp(/1. ([A-Za-zÀ-ÖØ-öø-ÿ ]+)\n2. [A-Za-zÀ-ÖØ-öø-ÿ ]+/)
const lastNameRegex = new RegExp(/^1. [A-Za-zÀ-ÖØ-öø-ÿ ]+/)
const firstNameRegex = new RegExp(/^2. [A-Za-zÀ-ÖØ-öø-ÿ ]+/)

var addressString, namesString, firstNameString, lastNameString;

var schemaTempInfo = {}

export default function validate(fullText) {

    var schemaCustomerInfo = {}

    fullText.forEach(element => {
        if (element.match(dobRegex)) {
            schemaTempInfo.dobDay = element.substring(3, 5)
            if (schemaTempInfo.dobDay !== undefined) {
                schemaCustomerInfo.dobDay = schemaTempInfo.dobDay
            }
            schemaTempInfo.dobMonth = element.substring(6, 8)
            if (schemaTempInfo.dobMonth !== undefined) {
                schemaCustomerInfo.dobMonth = schemaTempInfo.dobMonth
            }
            schemaTempInfo.dobYear = element.substring(9, 13)
            if (schemaTempInfo.dobYear !== undefined) {
                schemaCustomerInfo.dobYear = schemaTempInfo.dobYear
            }
        }

        if (element.match(namesRegex)) {
            namesString = element
            schemaTempInfo.lastName = namesString.substring(3, namesString.indexOf('\n') + 1).trim()
            if (schemaTempInfo.lastName !== undefined) {
                schemaCustomerInfo.lastName = schemaTempInfo.lastName
            }
            namesString = namesString.substring(namesString.indexOf('\n') + 1,).trim()
            let indexOfLastLetterOfFirstName = namesString.indexOf('\n')
            if (indexOfLastLetterOfFirstName === -1) {
                var match = namesString.match(/[A-Za-zÀ-ÖØ-öø-ÿ ]/g);
                indexOfLastLetterOfFirstName = namesString.lastIndexOf(match[match.length - 1]);
            }
            schemaTempInfo.firstName = namesString.substring(3, indexOfLastLetterOfFirstName + 1).trim()
            if (schemaTempInfo.firstName !== undefined) {
                schemaCustomerInfo.firstName = schemaTempInfo.firstName
            }
        }
        if (element.match(firstNameRegex)) {
            firstNameString = element
            // Check if there is a newline character and use that to end the string
            if(firstNameString.indexOf('\n') > 0) {
                schemaTempInfo.firstName = firstNameString.substring(3, firstNameString.indexOf('\n')).trim()
            } else {
                schemaTempInfo.firstName = firstNameString.substring(3, firstNameString.length).trim()
            }
            schemaCustomerInfo.firstName = schemaTempInfo.firstName
        }
        if (element.match(lastNameRegex)) {
            lastNameString = element
            // Check if there is a newline character and use that to end the string
            if(lastNameString.indexOf('\n') > 0) {
                schemaTempInfo.lastName = lastNameString.substring(3, lastNameString.indexOf('\n')).trim()
            } else {
                schemaTempInfo.lastName = lastNameString.substring(3, lastNameString.length).trim()
            }
            schemaCustomerInfo.lastName = schemaTempInfo.lastName

        }
        if (element.match(addressRegex)) {

            if (element.match(lineEight)) {
                addressString = element.substring(3,)
            } else if (!element.match(lineEight)) {
                addressString = element
            }

            schemaTempInfo.address1 = addressString.substring(0, addressString.indexOf(',')).trim()

            if (schemaTempInfo.address1 !== undefined) {
                schemaCustomerInfo.address1 = schemaTempInfo.address1
            }
            addressString = addressString.substring(addressString.indexOf(',') + 1,)

            schemaTempInfo.city = addressString.substring(1, addressString.indexOf(',')).trim()

            if (schemaTempInfo.city !== undefined) {
                schemaCustomerInfo.city = schemaTempInfo.city
            }

            addressString = addressString.substring(addressString.indexOf(',') + 1,)

            schemaTempInfo.postcode = addressString.substring(1,).trim()

            if (schemaTempInfo.postcode !== undefined) {
                schemaCustomerInfo.postcode = schemaTempInfo.postcode
            }
        }
    });

    return schemaCustomerInfo

};